let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k3dCC")).then(() => parcelRequire('dmfaU'));